"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaxCharValidation = void 0;
var Localize_1 = require("../../gen-src/Localize");
/**
 * A function which returns a localized validation message and state for character count validation
 * @param current the current value (or length) of the string to validate
 * @param maximum the maximum number of characters allowed
 */
function getMaxCharValidation(current, maximum) {
    var currentLength = typeof current === 'string' ? current.length : current;
    return {
        valid: currentLength > maximum ? false : undefined,
        message: Localize_1.Messages.characterCount({ COUNT: Localize_1.Formatters.formatCount(currentLength), MAXIMUM: Localize_1.Formatters.formatCount(maximum) }),
    };
}
exports.getMaxCharValidation = getMaxCharValidation;
//# sourceMappingURL=MaxCharValidation.js.map